import { BiomassEditCtrl } from "./biomass/biomass"
import { ConfirmDlg } from "./confirm/confirm"
import { AddCroppingPopupCtrl } from "./cropping/add/popup"
import { EditPlanCroppingCtrl } from "./cropping/cropping"
import { PlanEditCtrl } from "./edit"
import { PlanProductsEditCtrl } from "./products/products"
import { RateLimitsCtrl } from "./rate-limits/limits"
import { TemplateEditPopupCtrl } from "./template/template-edit"
import { TemplateManagePopupCtrl } from "./template/template-manage"

/// <reference path="edit.ts" />
/// <reference path="rate-limits/limits.ts" />
/// <reference path="template/template-edit.ts"/>
/// <reference path="template/template-manage.ts"/>
/// <reference path="confirm/confirm.ts" />

export function setupPlanEditor(module: ng.IModule) {

    module
        .directive("omniaNutriPlanEdit", PlanEditCtrl.create)
        .directive("omniaNutriPlanEditCropping", EditPlanCroppingCtrl.create)
        .directive("omniaNutriPlanEditCroppingPopup", AddCroppingPopupCtrl.create)
        .directive("omniaNutriPlanEditProducts", PlanProductsEditCtrl.create)
        .directive("omniaNutriPlanEditBiomass", BiomassEditCtrl.create)
        .directive("omniaNutriPlanTemplateEdit", TemplateEditPopupCtrl.create)
        .directive("omniaNutriPlanTemplateManage", TemplateManagePopupCtrl.create)
        .directive("omniaNutriPlanEditRateLimits", RateLimitsCtrl.create)
        .directive("omniaNutriPlanConfirmDlg", ConfirmDlg.create)


}
